module.exports = __webpack_public_path__ + "static/media/large-lite_2x.6db85047.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vehicles/large-lite_2x.png
// module id = 650
// module chunks = 27